import { Card } from '@zillow/constellation-10';
import React from 'react';

import type { ExpertiseCardProps } from './AuthorPage.types';
import Expertise from './Expertise';

/**
 * Card wrapper for the author's expertise tags.
 */
const ExpertiseCard: React.FC<ExpertiseCardProps> = ({ expertise }) => {
    return (
        // v8 <Box as={Card} cardType="secondary"> → plain v10 Card. cardType is
        // gone in v10; "secondary" only meant "no primary accent border", which
        // is the v10 default (tone="neutral", outlined, elevated).
        //
        // v10 Card merges the css prop through Panda's css(), so the v8 '&&&&'
        // specificity hack for beating Card's own padding is no longer needed.
        // v8 padding md (24px) → loose.
        <Card css={{ padding: 'loose' }}>
            <Expertise expertise={expertise} />
        </Card>
    );
};

export default ExpertiseCard;
